import { Backdrop, Button, Fade, IconButton, Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { InfoAwesomeIcon } from 'app/shared/icons';
import { IRootState } from 'app/shared/reducers';
import { Markup } from 'interweave';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import '../modal-style.scss';

export interface IErrorModalProps {
    className?: string;
    modal: boolean;
    message: string;
    txtButton?: string;
    txtLink?: string;
    link?: string;
    method?: string;
    setModal(data: boolean): void;
    checkRedirectToHome?(): void;
    actionOnClickOk?(): void;
    handleModalClose?(): void;
    handleContactUs?(): void;
    hideClose?: boolean;
    hideActionButtons?: boolean;
}

const ErrorModal = (props: IErrorModalProps) => {
    const {
        className,
        modal,
        message,
        txtButton,
        txtLink,
        link,
        method,
        setModal,
        checkRedirectToHome,
        actionOnClickOk,
        handleModalClose,
        handleContactUs,
        hideClose,
        hideActionButtons
    } = props;

    const { isMobile } = useSelector((state: IRootState) => state.cms);

    const getHrefContactUs = () => {
        if (!isMobile && method === 'tel') // Sur DESKTOP pas de lien pour appeler
            return '';
        else {
            return (method ? method + ':' : '') + (link ? link : '')
        }
    }
    const handleContactUsClick = (e) => {
        const hrefContactUs = getHrefContactUs()

        if (_.isEmpty(hrefContactUs)) {
            e.preventDefault();
            handleContactUs();
        }
    }
    const handleOkClick = () => {
        // On execute le code de la méthode envoyée dans les props
        if (actionOnClickOk) {
            actionOnClickOk();
        }

        if (checkRedirectToHome) {
            checkRedirectToHome();
        }
        setModal(false);
    }

    const handleCloseClick = () => {
        setModal(false);
        handleModalClose();
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={"modal-container" + (!isMobile ? " desktop-modal" : "")}
            open={modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={modal}>
                <div className="paper-info">
                    {!hideClose &&
                        <IconButton className="btn-close" onClick={handleCloseClick}>
                            <CloseIcon htmlColor="var(--primary-text)" />
                        </IconButton>
                    }
                    <InfoAwesomeIcon />
                    <div className={"paper-info-text " + (className ? className : "")}>
                        <Markup noWrap content={message} />
                    </div>
                    <br />
                    {!hideActionButtons &&
                        <div className={(!method && !link) || !txtButton ? 'row justify-content-center' : 'row'}>
                            {txtButton && <div className="col-6">
                                <Button variant="contained"
                                    className="btn btn-block"
                                    onClick={handleOkClick}
                                    disableElevation>
                                    {txtButton}
                                </Button>
                            </div>}
                            {(method || link || txtLink) &&
                                <div className="col-6">
                                    <a className="btn btn-link btn-block"
                                        onClick={(e) => handleContactUsClick(e)}
                                        href={getHrefContactUs()}>
                                        {txtLink}
                                    </a>
                                </div>
                            }
                        </div>
                    }
                </div>
            </Fade>
        </Modal>
    );
}

export default ErrorModal;
